export const SIMPLE_LEGEND_HEXAGON_AMOUNT = 5;
export const SIMPLE_LEGEND_SQUARE_AMOUNT = 6;
